import { cloneDeep } from 'lodash';
import {
  AccountClient,
  apiMethodAndKeyNames,
  GET_REQUESTERS_BY_CRITERIA,
  GET_TECHNICIANS_BY_CRITERIA,
  GET_CLIENTS,
  TicketClient
} from '@nile/graphql';
import { getTranslatedText, ALL_MODULES } from '@nile/components';

const getAccessor = (col) => {
  switch (col.name) {
    case 'prioritizedId':
      return 'displayId';
    case 'displayId':
      return 'displayId';
    case 'followers':
      return undefined;
    case 'resolutionTimer':
      return 'resolutionDueTimeLeft';
    case 'taskSummary':
      return 'totalTasks';
    default:
      return col.name;
  }
};

const getType = (col) => {
  switch (col.name) {
    case 'name':
      return 'Link';
    default:
      return 'Text';
  }
};

const getRuleAttribute = (f) => {
  switch (f.name) {
    case 'prioritizedId':
      return 'displayId';
    default:
      return f.name;
  }
};

const isEditable = (col) => {
  switch (col.name) {
    default:
      return false;
  }
};

const getDefaultValue = (f, condition) => {
  const operands = cloneDeep(condition.operands);
  const ruleIdx = operands.findIndex((el) => {
    if (f.dataType === 'entity') {
      return el.attribute === `${f.name}.name`;
    }
    return el.attribute === getRuleAttribute(f);
  });
  if (ruleIdx > -1) {
    const rule = operands[ruleIdx];
    switch (f.dataType) {
      case 'date':
      case 'datetime':
      case 'daterange':
        return rule.value;
      default:
        break;
    }
    switch (f.filterType) {
      case 'text':
      case 'numeric':
      case 'decimal':
      case 'paragraph':
      case 'read_only':
        return rule.value;
      default:
        return rule.value.map((el) => {
          return {
            name: el,
            value: el,
            label: el
          };
        });
    }
  }
  return '';
};

const isSortable = (col, availableAttributes) => {
  switch (col.name) {
    default:
      return true;
  }
};

const isFilterable = (col) => {
  switch (col?.name) {
    case 'name':
    case 'description':
      return true;
    default:
      return false;
  }
};

const checkDynamicQuery = (f) => {
  if (f.isCustom) return true;
  switch (f.name) {
    case 'client.name':
    case 'site.name':
    case 'subcategory':
    case 'subcause':
      return true;
    default:
      return false;
  }
};

const updateConditions = (params) => {
  const { condition, selectedField, viewConditions, setConditions } = params;
  if (condition?.operands?.length) {
    const currentConditions = cloneDeep(viewConditions) || {
      joinOperator: 'AND',
      operands: []
    };
    let updatedCondition = {};
    const ruleIdx = currentConditions.operands.findIndex((el) =>
      selectedField.dataType === 'entity'
        ? el.attribute === `${selectedField.name}.name`
        : el.attribute === getRuleAttribute(selectedField)
    );

    if (ruleIdx > -1) {
      currentConditions.operands[ruleIdx] = condition.operands[0];
      updatedCondition = currentConditions;
    } else {
      updatedCondition = {
        ...currentConditions,
        operands: currentConditions.operands.concat(condition.operands)
      };
    }
    setConditions(updatedCondition);
  } else {
    const currentConditions = cloneDeep(viewConditions);
    if (currentConditions) {
      const ruleIdx = currentConditions.operands.findIndex((el) =>
        selectedField.dataType === 'entity'
          ? el.attribute === `${selectedField.name}.name`
          : el.attribute === getRuleAttribute(selectedField)
      );
      if (ruleIdx > -1) {
        currentConditions.operands.splice(ruleIdx, 1);
        setConditions(
          currentConditions?.operands?.length
            ? {
                ...currentConditions,
                operands: currentConditions.operands
              }
            : null
        );
      }
    }
  }
};

export {
  getDefaultValue,
  checkDynamicQuery,
  isFilterable,
  isSortable,
  getAccessor,
  getType,
  isEditable,
  getRuleAttribute,
  updateConditions
};
